import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StyleService } from '../../services/style.service';

@Component({
  selector: 'app-swap-modal',
  templateUrl: './swap-modal.component.html',
  styleUrls: ['./swap-modal.component.scss']
})
export class SwapModalComponent {
  @Input() isSwapMode: boolean = true;
  @Input() itemsPerPage!: 4 | 6;
  @Input() swapItemsList: any[] = [];
  @Input() tab: any = null;

  @Output() selected: EventEmitter<any> = new EventEmitter();

  @Output() leave: EventEmitter<any> = new EventEmitter();

  constructor(
    public readonly styleService: StyleService,
  ) { }

  public get getSwapStyle(): any {
    const offerDetais = this.tab.configurations?.swapOfferCms;
    return offerDetais?.buttonTradeConfig;
  }

  public get getSwapHeaderStyle(): any {
    const swapOfferDetails = this.tab.configurations?.swapOfferCms;
    return swapOfferDetails?.selectTitleConfig;
  }

  public get getSwapHeaderText(): any {
    const swapBtn =
      this.tab.configurations.swapOfferCms?.selectTitle;
    return swapBtn?.length ? swapBtn : 'Select your new offer: ';
  }

  public get getSwapBack(): any {
    const swapBack =
      this.tab.configurations.swapOfferCms?.buttonBack;
    return swapBack?.length ? swapBack : 'Go Back';
  }

  public get getSwapBackStyle(): any {
    const swapBack = this.tab.configurations.swapOfferCms;
    return swapBack?.buttonBackConfig;
  }
  
  public get getSwapBackContinue(): any {
    const swapBack = this.tab.configurations.swapOfferCms;
    return swapBack?.buttonContinueConfig;
  }

  public get getSwapBackContinueDisabled(): any {
    const swapBack = this.tab.configurations.swapOfferCms;
    return swapBack?.buttonContinueDisabledConfig;
  }

  exitSwapMode() {
    this.leave.emit();
  }

  chooseOffer(card: any) {
    card.isSelected = !card.isSelected;
    this.swapItemsList.flat().forEach((element) => {
      if (card.id !== element.id || card.externalIdentifier !== element.externalIdentifier) element.isSelected = false;
    });
  }

  isNotChosenAnyReward() {
    return !this.swapItemsList.flat().some((element) => element.isSelected);
  }

  confirmSwap() {
    let selectedOffer = this.swapItemsList.flat().find((element) => element.isSelected === true);

    if (selectedOffer) {
      this.selected.emit(selectedOffer);
    }
  }
}
